import { render, staticRenderFns } from "./virtualCardEmailPreviewModal.vue?vue&type=template&id=f55a88c2&scoped=true&"
import script from "./virtualCardEmailPreviewModal.vue?vue&type=script&lang=js&"
export * from "./virtualCardEmailPreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./virtualCardEmailPreviewModal.vue?vue&type=style&index=0&id=f55a88c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55a88c2",
  null
  
)

export default component.exports